import React, { useState } from 'react';
import { useSetAtom } from 'jotai';
import PageWrapper from '../../../Components/Paper/PageWrapper';
import CustomSpotFilters from './CustomSpotFilters';
import SPOT_SORTING from '../Utils/constants';
import {
  formatWavePeriodValue,
  DEFAULT_STATS_TABS,
} from '../../../Utils/constants/general';
import { useAtomValue } from 'jotai';
import {
  searchValuesAtom,
  userBranchesAtom,
  selectedBranchAtom,
} from '../../../Atoms';
import { applyCallFilter } from '../../../Helpers/Filters/constants';
import getDefaultColumns from '../../../Components/ContactListWrapper/utils/getDefaultColumns';

const SpotCampaignsPage = function SpotCampaignsPage(props) {
  const userBranches = useAtomValue(userBranchesAtom);
  const selectedBranch = useAtomValue(selectedBranchAtom) || {};
  const setSearchValues = useSetAtom(searchValuesAtom);

  const onConfirmPeriod = (
    callFilterValue,
    lastCallOutcome,
    calledInCurrentPeriod,
    offer
  ) => {
    const callFilter = applyCallFilter(
      false, //checks if section is birthdays
      callFilterValue
    );
    const calledInPeriod =
      calledInCurrentPeriod === true ? calledInCurrentPeriod : null;

    setSearchValues((prev) => ({
      ...prev,
      ...callFilter,
      lastCallOutcome,
      calledInCurrentPeriod: calledInPeriod,
      tag: offer,
    }));
  };

  return (
    <PageWrapper
      columns={[
        ...getDefaultColumns(userBranches, selectedBranch),
        {
          id: 'tag',
          label: 'OFFER',
        },
      ]}
      statsTabs={DEFAULT_STATS_TABS}
      wavePeriod={formatWavePeriodValue()}
      period={120}
      customFilters={<CustomSpotFilters onConfirmPeriod={onConfirmPeriod} />}
      standardFilters={[
        { keyName: 'lastCallInCurrentMonth', operator: 'eq' },
        { keyName: 'lastCallOutcome' },
        { keyName: 'calledInCurrentPeriod', operator: 'eq' },
        { keyName: 'tag', operator: 'eq' },
      ]}
      rangeFilters={[]}
      sortingOptions={SPOT_SORTING}
      {...props}
    />
  );
};

export default SpotCampaignsPage;
